import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { useDebounce, useMerchantApiQuery } from "../hooks";

import { IRemoteDataContext, IViewApiKeys } from "../interfaces-and-types";
import { ApiKeysContext } from "./ApiKeysContext";

export function ApiKeysProvider({ children }: { children: React.ReactNode }) {
  const queryClient = useQueryClient();
  const [isRefreshing, setIsRefreshing] = useState<boolean>(true);
  const debouncePeriodElapsed = useDebounce(100, isRefreshing);

  const { isSuccess, isError, isLoading, data } =
    useMerchantApiQuery<IViewApiKeys>("getApiKeys", {
      enabled: debouncePeriodElapsed,
    });

  useEffect(() => {
    if (isRefreshing) {
      queryClient.refetchQueries(["getApiKeys"]);

      setIsRefreshing(false);
    }
  }, [isRefreshing]);

  const refreshRemoteData = () => {
    setIsRefreshing(true);
  };

  const memoedApiKeysContext = useMemo(() => {
    const unMemoedApiKeysContext: IRemoteDataContext<IViewApiKeys | null> = {
      isSuccess,
      isError,
      isLoading,
      data: data || null,
      refreshRemoteData,
    };

    return unMemoedApiKeysContext;
  }, [isLoading, isRefreshing /*, is_live*/]);

  return (
    <ApiKeysContext.Provider value={memoedApiKeysContext}>
      {children}
    </ApiKeysContext.Provider>
  );
}
